import React, { useState } from "react";
import PlayerMapping from "./palyer-mapping";
import Wall from "./wall";
import {  withRouter } from "react-router-dom";
import createPlayers from "./players-data";
import { GetData } from "../data-context";

/////////////////////////////////////////////////////////////

const initUtility = { wallState: false, time: "", selectedP1: false, selectedP2: false };
const players = createPlayers();

const PlayersChart = (props) => {
  const [utility, setUtility] = useState(initUtility);

  const { playerOne, playerTwo, setPlayerOne, setPlayerTwo } = GetData();

  let { wallState, selectedP1, selectedP2 } = utility;

  const handlePick = (player) => {
    if (selectedP1 === false) {
      setPlayerOne(player);
    }
    if (selectedP2 === false && selectedP1 === true) {
      setPlayerTwo(player);
    }
  };

  const togglePlayers = () => {
    if (selectedP1 === false) {
      setPlayerTwo(playerOne);
      setUtility({ ...utility, selectedP1: true });
    }
    if (selectedP1 === true && selectedP2 === false) {
      setUtility({ ...utility, selectedP2: true });
    }
  };

  const unSelect = () => {
    if (selectedP1 === false) {
      setPlayerOne("");
    }
    if (selectedP2 === false) {
      setPlayerTwo("");
    }
  };

  const handleWall = () => {
    if (selectedP1 && selectedP2) {
      setTimeout(() => {
        props.history.push("/fight");
      }, 1000);
      setUtility({ ...utility, wallState: true });
    }
  };

  return (
    <div className="d-flex justify-content-center">
      {wallState ? <Wall status="down" /> : ""}
      <div className="chart-size col-3 col-lg-2">
        <div className={`player-1 ${!selectedP1 && "darkly"}`}>
          <PlayerMapping action={selectedP1 ? "static" : "static"} player={playerOne} />
        </div>
        {selectedP1 && <h5>{playerOne.name}</h5>}
      </div>
      <div className="col-6 col-xs-12 col-lg-5">
        <div className="chart rounded p-2">
          <h6 className="text-mk">SELECT YOUR CHARACTER</h6>
          <div className="d-flex justify-content-center flex-wrap">
            {players.map((player, idx) => {
              return (
                <img
                  key={idx}
                  id={idx}
                  className={`thumb-fighter m-0 ${
                    selectedP1 && selectedP2 ? null : selectedP1 === false ? "blink" : "blink2"
                  }`}
                  src={player.thumb}
                  onMouseOver={() => handlePick(player)}
                  onClick={() => togglePlayers(player)}
                  onMouseOut={unSelect}
                  alt=""
                />
              );
            })}
            <div className="d-flex bg-dark rounded mt-4 w-100 justify-content-center p-2">
              <button
                className="chart-btn text-gothic btn btn-secondary"
                onClick={() => {
                  setUtility({ ...utility, selectedP1: false, selectedP2: false });
                  setPlayerOne("");
                  setPlayerTwo("");
                }}
              >
                <i className="fas fa-hand-point-up d-block" /> select
              </button>
              <button
                className={`chart-btn mx-3 text-gothic btn btn-${selectedP1 && selectedP2 ? "danger" : "secondary "}`}
                onClick={handleWall}
              >
                <i className="fas fa-fist-raised d-block" />
                fight
              </button>
              <button className="text-gothic btn btn-secondary" onClick={() => props.history.push("/settings")}>
                <i className="fas fa-cogs d-block" />
                settings
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="chart-size col-3 col-lg-2">
        <div className={`player-2 ${playerOne.name === playerTwo.name && "set-color"} ${!selectedP2 && "darkly"} `}>
          <PlayerMapping action={selectedP2 ? "static" : "static"} player={playerTwo} />
        </div>
        {selectedP2 && <h5>{playerTwo.name}</h5>}
      </div>
    </div>
  );
};

export default withRouter(PlayersChart);
